import { createStore, applyMiddleware, compose } from "redux";
import persistState from "redux-localstorage";
import { mediaQueryTracker } from "redux-mediaquery";
import { apiMiddleware } from "app/api";
import { topicFlowMiddleware } from "app/topics/middleware";
import { commentFlowMiddleware } from "app/comments/middleware";
import { authFlowMiddleware } from "app/auth/middleware";
import { toastMiddleware } from "app/layout/middleware";
import appReducer from "./reducers";
import * as media from "app/media";
import { getLocale, messages } from "./utils";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(
  applyMiddleware(
    apiMiddleware,
    topicFlowMiddleware,
    commentFlowMiddleware,
    authFlowMiddleware,
    toastMiddleware
  ),
  persistState(["auth", "intl"])
);

const locale = getLocale();

const initialState = {
  intl: {
    defaultLocale: "en-GB",
    locale: locale,
    messages: messages[locale]
  }
};

const store = createStore(appReducer, initialState, enhancer);

mediaQueryTracker(
  {
    tiny: media.maxWidth("xsmall"),
    xsmall: media.range("xsmall", "small"),
    small: media.range("small", "medium"),
    medium: media.range("medium", "large"),
    large: media.range("large", "xlarge"),
    xlarge: media.range("xlarge", "huge"),
    huge: media.minWidth("huge")
  },
  store.dispatch
);

export default store;



// WEBPACK FOOTER //
// ./src/app/store.js